import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card } from "react-bootstrap";
import API_URL from "../../localhost/config"; //Importa la variable global

function filaPartido(partido, index) {
  // console.log("El partido trae" + JSON.stringify(partido));
  return (
    <tr>
      <th scope="row">{index}</th>
      <td>{partido.equipo1.Nombre}</td>
      <td>{partido.equipo2.Nombre}</td>
      <td>{partido.dia}</td>
      <td>{partido.idTurno.horario}</td>
    </tr>
  );
}

function filaPartidoNoArreglado(partido, index) {
  // console.log("El partido trae" + JSON.stringify(partido));
  return (
    <tr>
      <th scope="row">{index}</th>
      <td>{partido.equipo1.Nombre}</td>
      <td>{partido.equipo2.Nombre}</td>
    </tr>
  );
}

function filaCanchasLibres(cancha, index) {
  return (
    <tr>
      <td>{cancha.dia}</td>
      <td>{cancha.idTurno.horario}</td>
      <td>{cancha.cancha}</td>
      {/* <td>{cancha.turno}</td> */}
    </tr>
  );
}

const ordenarPartidos = (partidos) => {
  return partidos.sort((a, b) => {
    const diasSemana = [
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
      "Domingo",
    ];

    // Obtener el índice del día de la semana para ambos partidos
    const diaA = diasSemana.indexOf(a.dia);
    const diaB = diasSemana.indexOf(b.dia);

    // Si los días de la semana son diferentes, ordenar por día
    if (diaA !== diaB) {
      return diaA - diaB;
    } else {
      // Si los días son iguales, ordenar por hora
      const horaA = parseInt(a.idTurno.horario);
      const horaB = parseInt(b.idTurno.horario);
      if (horaA !== horaB) {
        return horaA - horaB;
      }
    }
  });
};

const ordenarCanchaLibres = (partidos) => {
  return partidos.sort((a, b) => {
    // Convertir las fechas a objetos Date para comparar
    const fechaHoraA = new Date(a.fecha + " " + a.hora);
    const fechaHoraB = new Date(b.fecha + " " + b.hora);

    // Comparar por fecha
    if (fechaHoraA.getTime() !== fechaHoraB.getTime()) {
      return fechaHoraA.getTime() - fechaHoraB.getTime();
    } else {
      // Si las fechas son iguales, comparar por hora
      const horaA = parseInt(a.hora.split(":")[0]);
      const horaB = parseInt(b.hora.split(":")[0]);
      if (horaA !== horaB) {
        return horaA - horaB;
      } else {
        // Si las horas son iguales, ordenar por cancha
        return a.cancha.localeCompare(b.cancha);
      }
    }
  });
};

function ResultadoFlujo({ jsonResultadoFlujo, idTorneo }) {
  //console.log("Esto trae ResultadoFlujo" + JSON.stringify(jsonResultadoFlujo));
  const [infoCanchas, setInfoCanchas] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_URL}/getCourt`)
      .then((response) => {
        setInfoCanchas(response.data);
        // console.log("La info de cancha es " + JSON.stringify(response.data));
      })
      .catch((error) => {
        console.error("Error al llamar a la función del backend:", error);
      });
  }, []);

  return (
    <div>
      <div className="container text-center">
        {jsonResultadoFlujo &&
          infoCanchas.map((cancha) => {
            const partidosDeLaCancha = ordenarPartidos(
              jsonResultadoFlujo.armado.filter(
                (partido) =>
                  partido.cancha === cancha.Nombre &&
                  cancha.idTorneo === parseInt(idTorneo)
              )
            );

            if (partidosDeLaCancha.length > 0) {
              return (
                <div key={cancha.id} className="cancha-container">
                  <Card className="m-3" style={{ backgroundColor: "#cfe2ff" }}>
                    <div className="col-12">{cancha.Nombre}</div>
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Equipo 1</th>
                          <th scope="col">Equipo 2</th>
                          <th scope="col">Dia</th>
                          <th scope="col">Horario</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partidosDeLaCancha.map((partido, index) =>
                          filaPartido(partido, index + 1)
                        )}
                      </tbody>
                    </table>
                  </Card>
                </div>
              );
            }
            return null; // No hay partidos asociados a esta cancha, no se muestra nada
          })}
      </div>

      {jsonResultadoFlujo && jsonResultadoFlujo.noArmado.length > 0 ? (
        <div className="container text-center">
          <Card className="m-3" style={{ backgroundColor: "#cfe2ff" }}>
            <div className="col-12">Partidos no arreglados</div>
            <div className="row">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Equipo 1</th>
                      <th scope="col">Equipo 2</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jsonResultadoFlujo.noArmado.map((partido, index) =>
                      filaPartidoNoArreglado(partido, index + 1)
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Card>
        </div>
      ) : null}

      {jsonResultadoFlujo && jsonResultadoFlujo.canchasLibres.length > 0 ? (
        <div className="container text-center">
          <Card className="m-3" style={{ backgroundColor: "#cfe2ff" }}>
            <div className="col-12">Canchas Libres</div>
            <div className="row">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      {/* <th scope="col">#</th> */}
                      <th scope="col">Dia</th>
                      <th scope="col">Horario</th>
                      <th scope="col">Cancha</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ordenarCanchaLibres(jsonResultadoFlujo.canchasLibres).map(
                      (cancha, index) => filaCanchasLibres(cancha, index + 1)
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Card>
        </div>
      ) : null}
    </div>
  );
}

export default ResultadoFlujo;
